import apiClient from '@app/config/axios.config'
import { useEffect, useState } from 'react'

export interface ScenariosByAsset {
  hazard_scenario: string
  hazard_id: string
  is_exposed: 'true' | 'unknown' | 'false'
  hazard_name: string | null
  display_name: string
  sentence: string
  exposure_value: string
  vulnerability: string
  vulnerability_style: number
  hazard_extent_source: 'calculated' | 'authoritative' | 'none'
}

export const useScenariosFetcher = (
  selectedAssetType: string | undefined | null,
  selectedFeatureId: string | undefined | null,
  setIsLoading: (isLoading: boolean) => void,
): ScenariosByAsset[] | null => {
  const [scenarios, setScenarios] = useState(null)

  useEffect(() => {
    if (!selectedAssetType || !selectedFeatureId) {
      setIsLoading(false)
      return
    }
    setIsLoading(true)
    apiClient
      .get(`/hazard/scenarios/${selectedAssetType}/${selectedFeatureId}`)
      .then((response) => {
        setScenarios(response.data)
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching scenarios:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [selectedAssetType, selectedFeatureId, setIsLoading])

  return scenarios
}
